import "moment/min/locales";

import * as React from "react";
import * as XLSXStyle from "sheetjs-style";

import { Callout, DirectionalHint } from "@fluentui/react";
import {
  ConstrainMode,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Dropdown,
  IColumn,
  ScrollablePane,
  ScrollbarVisibility,
  Selection,
  ShimmeredDetailsList,
} from "@fluentui/react";
import { Fabric, Link } from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react";

import { ActivityDetails } from "../_components/ActivityDetails";
import { DetailsPanel } from "../_components/DetailsPanel";
import { Header } from "../_components/Header";
import { Icon } from "@fluentui/react";
import Moment from "moment";
import "moment-timezone";
import { PrimaryButton } from "@fluentui/react";
import ReactDOM from "react-dom";
import { Sidebar } from "../_components/Sidebar";
import i18n from "i18next";
import { request } from "http";
import { userService } from "../_services";

export interface Props {
  location: any;
  userData: any;
}

export interface ActivityState {
  userData: any;
  breadcrumb: any[];
  columns: IColumn[];
  items: any;
  calloutTarget: any;
  startIndex: number;
  indexSize: number;
  loadingActivity: boolean;
  isLoadingMoreActivity: boolean;
  canLoadMore: boolean;
  searchQuery: any;
  selItems: any;
  showRightPanel: boolean;
  currentPage: number;
  repoUsers: any;
  exporting: boolean;
  exportTimeZone: string;
  exportTimeZoneOptions: { key: string; text: string }[];
}

export interface IDocument {
  id: string;
  date: string;
  user: string;
  action: string;
  targets: any;
  source: any;
  destination: any;
  type: string;
  operationType: string;
  message: string;
  model_objects: any;
  old_2nd_model_objects: any;
  searchQuery: string;
}

export class Activity extends React.Component<Props, ActivityState> {
  private _isMounted: boolean;
  private headerRef: any = React.createRef();
  private sidebarRef: any = React.createRef();
  private _selection: Selection;

  constructor(props: any) {
    super(props);
    this._isMounted = false;

    this._selection = new Selection({
      onSelectionChanged: () => {
        var selItem: any = this._selection.getSelection()[this._selection.getSelection().length - 1];

        setTimeout(() => {
          if (selItem && this._selection.getSelectedCount() === 1) {
            this._isMounted && this.setState({ selItems: selItem });
          } else if (selItem && this._selection.getSelectedCount() > 1) {
            this._isMounted && this.setState({ selItems: null });
          } else if (this._selection.getSelectedCount() === 0) {
            this._isMounted && this.setState({ selItems: null });
          }
        }, 50);
      },
    });

    const messages: any = i18n.t("activityMessages:messages", { returnObjects: true });
    let companyUrl = this.props.userData?.repository.domain.replaceAll(".com", "").replaceAll(".", "-");
    const columns: IColumn[] = [
      {
        key: "date",
        name: i18n.t("activity:date"),
        fieldName: "dateValue",
        isSorted: true,
        isSortedDescending: true,
        sortAscendingAriaLabel: "Sorted A to Z",
        sortDescendingAriaLabel: "Sorted Z to A",
        minWidth: 100,
        maxWidth: 100,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: "number",
        onRender: (item: IDocument) => {
          return <span>{Moment(item.date).format("Y-MM-DD HH:mm")}</span>;
        },
        isPadded: true,
      },
      {
        key: "user",
        name: i18n.t("activity:user"),
        fieldName: "user",
        minWidth: 100,
        maxWidth: 160,
        isRowHeader: true,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
        onRender: (item: IDocument) => {
          return (
            <div>
              <span title={item.user}>{item.user}</span>
            </div>
          );
        },
      },
      {
        key: "action",
        name: i18n.t("activity:activity"),
        fieldName: "action",
        minWidth: 120,
        maxWidth: 160,
        isRowHeader: true,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
        onRender: (item: IDocument) => {
          return (
            <div>
              <span className="activity-description" title={item.action || i18n.t("app:unknown")}>
                {item.action || i18n.t("app:unknown")}
              </span>
            </div>
          );
        },
      },
      {
        key: "item",
        name: i18n.t("activity:item"),
        fieldName: "item",
        minWidth: 100,
        maxWidth: 160,
        isRowHeader: true,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
        columnActionsMode: 0,
        onRender: (item: IDocument) => {
          var itemText: string = "";
          if (item.type === "DOCUMENT" && item.operationType === "SEARCH") {
            itemText = "Files";
            return (
              <div>
                <span title={itemText}>{itemText}</span>
              </div>
            );
          } else if (
            item.operationType === "DUPLICATE" &&
            item.targets &&
            item.targets.length > 0 &&
            item.targets[0].modelType === "FILE"
          ) {
            return (
              <div>
                <Link
                  className="mr-2"
                  href={"https://synergyos.com/" + companyUrl + "/path/" + item.targets[0].id}
                  title={item.targets[0].name ?? "FILE"}
                >
                  {item.targets[0].name ?? "FILE"}
                </Link>
              </div>
            );
          } else if (item.operationType === "DUPLICATE" && item.destination && item.destination.modelType === "FILE") {
            return (
              <div>
                <Link
                  className="mr-2"
                  href={"https://synergyos.com/" + companyUrl + "/path/" + item.destination.id}
                  title={item.destination.name ?? "FILE"}
                >
                  {item.destination.name ?? "FILE"}
                </Link>
              </div>
            );
          } else if (item.operationType === "DUPLICATE" && item.source && item.source.modelType === "FOLDER") {
            return (
              <div>
                <Link
                  className="mr-2"
                  href={"https://synergyos.com/" + companyUrl + "/drive/" + item.source.id}
                  title={item.source.name ?? "FOLDER"}
                >
                  {item.source.name ?? "FOLDER"}
                </Link>
              </div>
            );
          } else if (
            item.operationType === "SEARCH" &&
            item.targets &&
            item.targets[0] &&
            (item.targets[0].modelType === "FILE" || item.targets[0].modelType === "FOLDER")
          ) {
            return (
              <div>
                <span>
                  {item.targets[0].modelType === "FOLDER" ? i18n.t("policies:folders") : i18n.t("policies:files")}
                </span>
              </div>
            );
          } else if (item.operationType === "SEARCH" && !item.targets) {
            return (
              <div>
                <span>{i18n.t("policies:folders") + "/" + i18n.t("policies:files")}</span>
              </div>
            );
          } else if (item.operationType === "SHARE" && item.source) {
            return (
              <div>
                <Link
                  className="mr-2"
                  href={"https://synergyos.com/" + companyUrl + "/drive/" + item.source.id}
                  title={item.source.name ?? "FOLDER"}
                >
                  {item.source.name ?? "FOLDER"}
                </Link>
              </div>
            );
          } else if (item.targets && item.targets.length > 0) {
            let files = item.targets.filter((t) => {
              return t.modelType === "FILE";
            });
            let folders = item.targets.filter((t) => {
              return t.modelType === "FOLDER";
            });
            if (files.length > 0 && folders.length > 0) {
              return (
                <div>
                  <span
                    id={item.id}
                    title={itemText}
                    onClick={() => this.setState({ calloutTarget: item })}
                    className="cursor-pointer mr-2"
                  >
                    {files.length + folders.length + " " + i18n.t("activity:items")}{" "}
                    <Icon iconName="CaretDownSolid8" className="small align-bottom ml-1" />
                  </span>
                </div>
              );
            } else if (files.length > 1) {
              return (
                <div>
                  <span
                    id={item.id}
                    title={itemText}
                    onClick={() => this.setState({ calloutTarget: item })}
                    className="cursor-pointer"
                  >
                    {files.length + " " + i18n.t("activity:files")}{" "}
                    <Icon iconName="CaretDownSolid8" className="small align-bottom ml-1" />
                  </span>
                </div>
              );
            } else if (folders.length > 1) {
              return (
                <div>
                  <span
                    id={item.id}
                    title={itemText}
                    onClick={() => this.setState({ calloutTarget: item })}
                    className="cursor-pointer"
                  >
                    {folders.length + " " + i18n.t("activity:folders")}{" "}
                    <Icon iconName="CaretDownSolid8" className="small align-bottom ml-1" />
                  </span>
                </div>
              );
            } else if (item.targets[0] && item.targets[0].modelType === "GROUP") {
              return (
                <div>
                  <span title={item.targets[0].name}>{item.targets[0].name}</span>
                </div>
              );
            } else {
              return item.targets.map((target) => {
                if (target.modelType === "USER") {
                  return (
                    <div>
                      <Link href={"mail:" + target.email} title={target.email}>
                        {target.email}
                      </Link>
                    </div>
                  );
                } else if (target.modelType === "FILE" || target.modelType === "COMMENT") {
                  return (
                    <div>
                      <Link
                        className="mr-2"
                        href={"https://synergyos.com/" + companyUrl + "/path/" + target.id}
                        title={target.name ?? "FILE"}
                      >
                        {target.name ?? "FILE"}
                      </Link>
                    </div>
                  );
                } else if (target.modelType === "FOLDER") {
                  return (
                    <div>
                      <Link
                        className="mr-2"
                        href={"https://synergyos.com/" + companyUrl + "/drive/" + target.id}
                        title={target.name ?? "FOLDER"}
                      >
                        {target.name ?? "FOLDER"}
                      </Link>
                    </div>
                  );
                } else if (target.modelType === "REVISION") {
                  return (
                    <div>
                      <Link
                        className="mr-2"
                        href={"https://synergyos.com/" + companyUrl + "/path/" + target.id}
                        title={target.name ?? item.source?.name ?? "FILE"}
                      >
                        {target.name ?? item.source?.name ?? "FILE"}
                      </Link>
                    </div>
                  );
                } else if (target.modelType === "TAG") {
                  return (
                    <div>
                      <Link
                        className="mr-2"
                        href={"https://synergyos.com/" + companyUrl + "/path/" + target.id}
                        title={target.name ?? "FILE"}
                      >
                        {target.name ?? "FILE"}
                      </Link>
                    </div>
                  );
                } else if (target.modelType === "SMART_FOLDER") {
                  return (
                    <div>
                      <span></span>
                    </div>
                  );
                } else if (target.modelType === "ZIP") {
                  return (
                    <div>
                      <span title={target.name}>{target.name ?? "ZIP"}</span>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <span title={messages.UNKNOWN_TARGET.DEFAULT}>{messages.UNKNOWN_TARGET.DEFAULT}</span>
                    </div>
                  );
                }
              });
            }
          } else {
            return (
              <div>
                <span title={itemText || "Unknown"}>{itemText || "Unknown"}</span>
              </div>
            );
          }
        },
      },
      {
        key: "details",
        name: i18n.t("activity:details"),
        fieldName: "details",
        minWidth: 120,
        isRowHeader: true,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
        columnActionsMode: 0,
        onRender: (item: IDocument) => {
          return <ActivityDetails userData={this.props.userData} repoUsers={this.state.repoUsers} item={item} />;
        },
      },
    ];

    const exportTimeZoneOptions: any[] = Moment.tz
      .names()
      .map((zone) => {
        const offsetMinutes = Moment.tz(zone).utcOffset();
        const sign = offsetMinutes >= 0 ? "+" : "-";
        const absMinutes = Math.abs(offsetMinutes);
        const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
        const minutes = String(absMinutes % 60).padStart(2, "0");
        const offsetLabel = `UTC${sign}${hours}:${minutes}`;
        return { key: zone, text: `${offsetLabel} — ${zone}`, offsetMinutes };
      })
      .sort((a, b) => a.offsetMinutes - b.offsetMinutes || a.text.localeCompare(b.text));

    this.state = {
      userData: null,
      breadcrumb: [],
      columns: columns,
      items: [],
      calloutTarget: null,
      startIndex: 0,
      indexSize: 50,
      loadingActivity: true,
      isLoadingMoreActivity: false,
      canLoadMore: false,
      searchQuery: [],
      selItems: null,
      showRightPanel: true,
      currentPage: 0,
      repoUsers: [],
      exporting: false,
      exportTimeZone: Moment.tz.guess(),
      exportTimeZoneOptions,
    };
  }

  public componentDidMount() {
    this._isMounted = true;
    if (this.props.userData) {
      userService.getRepoUsers(this.props.userData.repository.id, "ALL", "").then((response) => {
        let repoUsers = response.data;
        repoUsers.groups = [];
        userService.getGroups(this.props.userData.repository.id, "ALL").then((response: any) => {
          var groups = response.data;
          groups.forEach((group) => {
            repoUsers.groups.push(group);
          });
          var groupsData = repoUsers.groups;
          for (let i = 0; i < groupsData.length; i++) {
            let groupData = groupsData[i];
            var groupUsers = groupData.users.map((user) => {
              var matchUser = repoUsers.filter((repoUser) => {
                return repoUser.id === user;
              })[0];
              return matchUser;
            });
            if (groupUsers) groupData.users = groupUsers;
          }
          this._isMounted && this.setState({ repoUsers: repoUsers });
          this.setBreadcrumb();
          this._getActivity();
        });
      });
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.userData !== prevProps.userData) {
      userService.getRepoUsers(this.props.userData.repository.id, "ALL", "").then((response) => {
        let repoUsers = response.data;
        userService.getGroups(this.props.userData.repository.id, "ALL").then((response: any) => {
          var groups = response.data;
          repoUsers.groups = [];
          groups.forEach((group) => {
            repoUsers.groups.push(group);
          });
          var groupsData = repoUsers.groups;
          for (let i = 0; i < groupsData.length; i++) {
            let groupData = groupsData[i];
            var groupUsers = groupData.users.map((user) => {
              var matchUser = repoUsers.filter((repoUser) => {
                return repoUser.id === user;
              })[0];
              return matchUser;
            });
            if (groupUsers) groupData.users = groupUsers;
          }
          this._isMounted && this.setState({ repoUsers: repoUsers });
          this.setBreadcrumb();
          this._getActivity();
        });
      });
    }

    if (prevProps.location.search !== this.props.location.search) {
      this._isMounted &&
        this.props.userData &&
        this.setState(
          {
            items: [],
            startIndex: 0,
          },
          () => {
            this.setBreadcrumb();
            this._getActivity();
          },
        );
    }
  }

  private setBreadcrumb() {
    this._isMounted &&
      this.setState({
        breadcrumb: [
          {
            text: "Activity",
            key: "/activity",
            onClick: this.headerRef._onBreadcrumbItemClicked.bind(this),
          },
        ],
      });
  }

  public render() {
    const { columns, items, loadingActivity, isLoadingMoreActivity, canLoadMore } = this.state;

    const callbackFunction = (childData) => {
      this._isMounted && this.setState(childData);
    };
    let companyUrl = this.props.userData?.repository.domain.replaceAll(".com", "").replaceAll(".", "-");
    return (
      <Fabric>
        <Header
          ref={(instance: any) => {
            this.headerRef = instance;
          }}
          userData={this.props.userData}
          breadcrumb={this.state.breadcrumb}
          actions="activity"
          getActivity={this._refreshCurrentContent.bind(this)}
          exportActivity={this._exportActivity.bind(this)}
          exporting={this.state.exporting}
          sidebarRef={this.sidebarRef}
          callbackFunction={callbackFunction}
          showRightPanel={this.state.showRightPanel}
        />

        <div className="content-wrap d-flex flex-row">
          <div className="fakeLine"></div>
          <Sidebar
            ref={(instance: any) => {
              this.sidebarRef = instance;
            }}
            userData={this.props.userData}
            searchQuery={this.props.location.search}
          />

          <div className="list mr-auto flex-grow-1">
            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
              <ShimmeredDetailsList
                items={items}
                compact={true}
                columns={columns}
                setKey="set"
                isHeaderVisible={true}
                enableShimmer={loadingActivity && !isLoadingMoreActivity}
                constrainMode={ConstrainMode.unconstrained}
                ariaLabelForShimmer="Content is being fetched"
                enterModalSelectionOnTouch={true}
                ariaLabelForSelectionColumn="Toggle selection"
                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                checkButtonAriaLabel="Row checkbox"
                shimmerLines={12}
                selection={this._selection}
              />

              {canLoadMore && items && items.length > 0 ? (
                <div className="load-more text-center p-3 w-100">
                  <PrimaryButton
                    onClick={this._getActivity.bind(this, this.state.currentPage + 1)}
                    text="Load more activity"
                    disabled={isLoadingMoreActivity}
                    className="w-50"
                  />
                  {isLoadingMoreActivity ? <Spinner size={SpinnerSize.xSmall} className="d-inline-block ms-2" /> : null}
                </div>
              ) : null}
            </ScrollablePane>

            {this.state.calloutTarget ? (
              <Callout
                className={"activity-items-callout"}
                gapSpace={0}
                target={`#${this.state.calloutTarget.id}`}
                isBeakVisible={true}
                onDismiss={() => this.setState({ calloutTarget: null })}
                directionalHint={DirectionalHint.bottomLeftEdge}
                setInitialFocus
              >
                <ul className="m-0 p-0" style={{ listStyleType: "none" }}>
                  {this.state.calloutTarget.targets.map((target) => {
                    if (target.modelType === "FOLDER") {
                      return (
                        <li key={target.id} className="mb-2">
                          <Link href={"https://synergyos.com/" + companyUrl + "/drive/" + target.id} title={target.id}>
                            {target.name ?? "Folder"}
                          </Link>
                        </li>
                      );
                    } else if (target.modelType === "FILE") {
                      return (
                        <li key={target.id} className="mb-2">
                          <Link href={"https://synergyos.com/" + companyUrl + "/path/" + target.id} title={target.id}>
                            {target.name ?? "FILE"}
                          </Link>
                        </li>
                      );
                    } else return <li></li>;
                  })}
                </ul>
              </Callout>
            ) : null}

            {this.state.items.length === 0 && !this.state.loadingActivity && !this.state.isLoadingMoreActivity ? (
              <div className="empty-folder-msg p-3">
                <p className="text-center text-secondary mt-5 mx-auto px-3">No activity matches the current filters</p>
              </div>
            ) : null}
          </div>
          <DetailsPanel
            //ref={instance => { this.detailsPanelRef = instance; }}
            userData={this.props.userData}
            repoUsers={this.state.repoUsers}
            //items={ companies }
            showRightPanel={this.state.showRightPanel}
            selItem={this.state.selItems}
            headerRef={this.headerRef}
            _selection={this._selection}
            detailsPanelSection="activity"
            callbackFunction={callbackFunction}
          />
        </div>
      </Fabric>
    );
  }

  private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
    const { columns, items } = this.state;
    const newColumns: IColumn[] = columns.slice();
    const currColumn: IColumn = newColumns.filter((currCol) => column.key === currCol.key)[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    var newItems = _copyAndSort(items, currColumn.fieldName!, currColumn.isSortedDescending);

    localStorage.setItem("dashboardColumns", JSON.stringify(newColumns));

    this._isMounted &&
      this.setState({
        columns: newColumns,
        items: newItems,
      });
  };

  private _buildActivityRequestOptions() {
    const params = new URLSearchParams(this.props.location.search);
    var modelQuery = params.get("modelTypes");
    var operationQuery = params.get("operationTypes");
    var userId = params.get("user_id");
    var initialDate: any = params.get("initialDate");
    if (!initialDate) initialDate = new Date(2020, 0, 1).getTime();
    var finalDate: any = params.get("finalDate");
    if (!finalDate) {
      finalDate = new Date(Date.now());
      finalDate.setHours(23, 59, 59, 999);
      finalDate = finalDate.getTime();
    }

    const requestOptions: any = { application: "DRIVE" };
    if (operationQuery) requestOptions.operationTypes = [operationQuery];
    if (modelQuery) requestOptions.modelTypes = [modelQuery];
    if (initialDate) requestOptions.initialDate = initialDate;
    if (finalDate) requestOptions.finalDate = finalDate;
    if (userId) requestOptions.userId = userId;
    requestOptions.repo = this.props.userData.repository.id;

    return requestOptions;
  }

  private _mapActivityItem(data: any, repoUsers: any[]) {
    var messages: any = i18n.t("activityMessages:messages", { returnObjects: true });

    var message = messages.UNKNOWN_OPERATION.DEFAULT;
    if (messages[data.operationType]) {
      if (data.targets && data.targets[0] && messages[data.operationType][data.targets[0].modelType]) {
        message = messages[data.operationType][data.targets[0].modelType];
      } else if (data.source && messages[data.operationType][data.source.modelType]) {
        message = messages[data.operationType][data.source.modelType];
      } else {
        message = messages[data.operationType].DEFAULT;
      }
    }

    var model_objects =
      data.model_objects &&
      data.model_objects.sort((a: any, b: any) => {
        var aType = a.op_related_names || "";
        var bType = b.op_related_names || "";
        var aName = a.name && a.name.toLowerCase();
        var bName = b.name && b.name.toLowerCase();

        if (aType === bType) {
          return aName < bName ? -1 : aName > bName ? 1 : 0;
        } else {
          return aType < bType ? 1 : -1;
        }
      });

    let user: any = repoUsers.find((user: any) => {
      return user.id === data.userId;
    });

    let userFullName = "";
    if (user) userFullName = (user.name || "") + " " + (user.surname || "");

    if (data.targets) {
      let targets: any[] = data.targets;
      for (let i in targets) {
        if (targets[i].modelType === "USER") {
          let user: any = repoUsers.find((user: any) => {
            return user.id === targets[i].id;
          });
          if (user) targets[i] = { ...user, ...targets[i] };
          else targets[i] = messages.UNKNOWN_TARGET.DEFAULT;
        }
      }
    }

    return {
      id: data.id,
      userId: data.userId,
      date: data.date,
      dateValue: data.date,
      user: userFullName,
      action: message,
      targets: data.targets,
      source: data.source,
      destination: data.destination,
      item: model_objects,
      operationType: data.operationType,
      message: data.message,
      model_objects: data.model_objects,
      old_2nd_model_objects: data.old_2nd_model_objects,
      searchQuery: data.search_query_map,
      type: data.type,
      operation: data.operation,
      users: data.users,
      activityType: data.activityType,
      path: data.path,
      userType: data.userType,
    };
  }

  private _getActivity(currentPage = 0) {
    this._isMounted && this.setState({ loadingActivity: true });
    this._isMounted &&
      this.state.items.length > 0 &&
      this.setState({
        isLoadingMoreActivity: true,
      });

    const requestOptions = this._buildActivityRequestOptions();

    userService
      .searchActivity("?page=" + currentPage, requestOptions)
      .then((response: any) => {
        const { repoUsers } = this.state;
        var activity = response.data.content;
        var activityItems = activity.map((data: any) => this._mapActivityItem(data, repoUsers));

        activityItems = activityItems.sort((a: any, b: any) => {
          if (a.dateValue < b.dateValue) return 1;
          if (b.dateValue < a.dateValue) return -1;

          return 0;
        });

        this._isMounted &&
          this.setState((prevState) => {
            const items = [...prevState.items, ...activityItems];
            return { items };
          });

        var canLoadMore = !response.data.last;

        this.setState({
          loadingActivity: false,
          isLoadingMoreActivity: false,
          canLoadMore: canLoadMore,
          currentPage: currentPage,
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private _refreshCurrentContent() {
    this._isMounted &&
      this.setState(
        {
          items: [],
          startIndex: 0,
          canLoadMore: false,
        },
        () => {
          this._getActivity();
        },
      );
  }

  private _getItemEntries(item: any) {
    let itemText = "";
    if (item.type === "DOCUMENT" && item.operationType === "SEARCH") {
      return [{ text: "Files", id: "", modelType: "" }];
    } else if (
      item.operationType === "DUPLICATE" &&
      item.targets &&
      item.targets.length > 0 &&
      item.targets[0].modelType === "FILE"
    ) {
      return [{ text: item.targets[0].name ?? "FILE", id: item.targets[0].id ?? "", modelType: "FILE" }];
    } else if (item.operationType === "DUPLICATE" && item.destination && item.destination.modelType === "FILE") {
      return [{ text: item.destination.name ?? "FILE", id: item.destination.id ?? "", modelType: "FILE" }];
    } else if (item.operationType === "DUPLICATE" && item.source && item.source.modelType === "FOLDER") {
      return [{ text: item.source.name ?? "FOLDER", id: item.source.id ?? "", modelType: "FOLDER" }];
    } else if (
      item.operationType === "SEARCH" &&
      item.targets &&
      item.targets[0] &&
      (item.targets[0].modelType === "FILE" || item.targets[0].modelType === "FOLDER")
    ) {
      return [
        {
          text: item.targets[0].modelType === "FOLDER" ? i18n.t("policies:folders") : i18n.t("policies:files"),
          id: item.targets[0].id ?? "",
          modelType: item.targets[0].modelType ?? "",
        },
      ];
    } else if (item.operationType === "SEARCH" && !item.targets) {
      return [{ text: i18n.t("policies:folders") + "/" + i18n.t("policies:files"), id: "", modelType: "" }];
    } else if (item.operationType === "SHARE" && item.source) {
      return [{ text: item.source.name ?? "FOLDER", id: item.source.id ?? "", modelType: item.source.modelType ?? "" }];
    } else if (item.targets && item.targets.length > 0) {
      const targetEntries = item.targets
        .map((target) => {
          let text = "";
          if (target.modelType === "USER") text = target.email ?? target.name ?? "";
          else if (target.modelType === "FILE" || target.modelType === "COMMENT") text = target.name ?? "FILE";
          else if (target.modelType === "FOLDER") text = target.name ?? "FOLDER";
          else if (target.modelType === "REVISION") text = target.name ?? item.source?.name ?? "FILE";
          else if (target.modelType === "TAG") text = target.name ?? "FILE";
          else if (target.modelType === "ZIP") text = target.name ?? "ZIP";
          else if (target.modelType === "GROUP") text = target.name ?? "";
          if (!text) return null;
          return { text, id: target.id ?? "", modelType: target.modelType ?? "" };
        })
        .filter(Boolean);
      if (targetEntries.length > 0) return targetEntries;
    }

    return [{ text: itemText || "Unknown", id: "", modelType: "" }];
  }

  private _getDetailsText(item: any) {
    var model_objects: any = item.model_objects;
    var old_2nd_model_objects: any = item.old_2nd_model_objects;
    var object = model_objects && model_objects[0];
    var secondaryObject = old_2nd_model_objects && old_2nd_model_objects[0];
    var activityDetails: string = "";

    if (item.operationType === "SEARCH") {
      activityDetails = (item.message || "").replace(/[{}]/g, "");
    } else if (
      (item.operationType === "DEMOTE" || item.operationType === "PROMOTE") &&
      item.destination &&
      item.destination.modelType === "REVISION"
    ) {
      let version = "";
      if ((item.destination.version || "").includes("-draft")) {
        version = i18n.t("activity:draftPost") + " v" + item.destination.version.replace("-draft", "");
      } else if ((item.destination.version || "").includes("Draft post-")) {
        version = i18n.t("activity:draftPost") + " v" + item.destination.version.replace("Draft post-", "");
      } else version = "v" + item.destination.version;
      activityDetails = version + (item.message ? ' "' + item.message + '"' : "");
    } else if (item.targets && item.targets[0] && item.targets[0].modelType === "REVISION") {
      let version = "";
      if ((item.targets[0].version || "").includes("-draft")) {
        version = i18n.t("activity:draftPost") + " v" + item.targets[0].version.replace("-draft", "");
      } else if ((item.targets[0].version || "").includes("Draft post-")) {
        version = i18n.t("activity:draftPost") + " v" + item.targets[0].version.replace("Draft post-", "");
      } else version = "v" + item.targets[0].version;
      activityDetails = version + (item.message ? ' "' + item.message + '"' : "");
    } else if (item.targets && item.targets.length === 1 && item.targets[0] && item.targets[0].modelType === "FILE") {
      let version = "";
      if (item.targets && item.targets[0] && (item.targets[0].version || "").includes("-draft")) {
        version = i18n.t("activity:draftPost") + " v" + item.targets[0].version.replace("-draft", "");
      } else if (item.targets && item.targets[0] && (item.targets[0].version || "").includes("Draft post-")) {
        version = i18n.t("activity:draftPost") + " v" + item.targets[0].version.replace("Draft post-", "");
      } else if (item.targets && item.targets[0]) {
        version = "v" + item.targets[0].version;
      }
      let version2 = "";
      if (item.source && (item.source.version || "").includes("-draft")) {
        version2 = i18n.t("activity:draftPost") + " v" + item.source.version.replace("-draft", "");
      } else if (item.source && (item.source.version || "").includes("vDraft post-")) {
        version2 = i18n.t("activity:draftPost") + " v" + item.source.version.replace("vDraft post-", "");
      } else if (item.source && item.source.version) {
        version2 = "v" + item.source.version;
      }
      activityDetails = version || version2;
    } else if (
      item.operationType.includes("SHARE") &&
      item.targets &&
      item.targets[0] &&
      item.targets[0].modelType === "GROUP"
    ) {
      const groups = (this.state.repoUsers && this.state.repoUsers.groups) || [];
      const groupNames = item.targets
        .map((target) => {
          const group = groups.find((g) => g.id === target.id);
          return group ? group.name : target.name;
        })
        .filter(Boolean);
      activityDetails = groupNames.join(", ");
    } else if (item.targets && item.targets[0] && item.targets[0].modelType === "SMART_FOLDER") {
      activityDetails = item.targets[0].name;
    } else if (item.targets && item.targets[0] && item.targets[0].modelType === "COMMENT") {
      activityDetails = item.message;
    } else if (item.targets && item.targets[0] && item.targets[0].modelType === "TAG") {
      activityDetails = item.message;
    } else if (item.users && item.users.length > 0) {
      const users = item.users
        .map((target) => {
          let user = this.state.repoUsers.find((g) => {
            return g.id === target;
          });
          return user ? (user.name || "") + " " + (user.surname || "") : "";
        })
        .filter(Boolean);
      activityDetails = users.join(", ");
    }

    if (item.operationType === "DUPLICATE") {
      if (item.source && item.source.modelType === "FILE") {
        activityDetails = item.source.name;
      }
    }

    if (item.operationType === "MOVE") {
      if (item.destination && item.source) {
        activityDetails =
          i18n.t("activity:from") + " " + item.destination.name + " " + i18n.t("activity:to") + " " + item.source.name;
      } else {
        activityDetails = item.message;
      }
    }

    if (item.operationType === "RENAME") {
      activityDetails = i18n.t("activity:previousName") + ": " + item.source?.name;
    }

    if (item.operationType === "CREATE_SHARE_BY_LINK") {
      activityDetails = "";
    }

    if (item.type === "COMPANY") {
      if (item.operation === "ADD_INTERNAL" && object) {
        activityDetails = "email: " + object.email;
      }
    }

    if (item.type === "GROUP") {
      if ((item.operation === "CREATE" || item.operation === "UPDATE") && secondaryObject) {
        activityDetails = i18n.t("activity:name") + ': "' + secondaryObject.name + '"';
      }
    }

    if (item.operation === "SEARCH" && item.message) {
      var message = item.message.substring(1, item.message.length - 1);
      message = message.split(", ");
      message = message.filter((term) => {
        return !term.startsWith("parentId");
      });
      message = message.join(", ");
      activityDetails = message;
    }

    if (item.operationType === "COMPARE" && item.targets && item.targets.length >= 2) {
      var file1 = item.targets[0];
      var file2 = item.targets[1];
      if (file1 && file2 && file1.id === file2.id) {
        activityDetails = (file1.name ?? "FILE") + " v" + file1.version + " vs. v" + file2.version;
      } else if (file1 && file2) {
        activityDetails =
          (file1.name ?? "FILE") + " v" + file1.version + " vs. " + (file2.name ?? "FILE") + " v" + file2.version;
      }
    }

    return activityDetails || "";
  }

  private _getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [" KB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }

  private _getUtcOffsetMinutes(label: string) {
    if (!label) return 0;
    try {
      return Moment.tz(label).utcOffset();
    } catch {
      return 0;
    }
  }

  private _confirmLargeExport(totalPages: number) {
    return new Promise((resolve) => {
      let showDialog = true;
      let selectedTimeZone = this.state.exportTimeZone;
      const div = document.createElement("div");
      const renderDialog = () => {
        ReactDOM.render(
          <Dialog
            hidden={!showDialog}
            dialogContentProps={{
              type: DialogType.normal,
              title: <div>{i18n.t("activity:exportLargeWarningTitle")}</div>,
              subText: i18n.t("activity:exportLargeWarningBody", { totalPages }),
            }}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 640 } },
              dragOptions: undefined,
            }}
            onDismiss={() => {
              showDialog = false;
              renderDialog();
              resolve(false);
            }}
          >
            <Dropdown
              label={i18n.t("activity:timezone")}
              defaultSelectedKey={selectedTimeZone}
              options={this.state.exportTimeZoneOptions}
              onChange={(_e, option: any) => {
                if (option?.key) {
                  selectedTimeZone = option.key;
                  this._isMounted && this.setState({ exportTimeZone: option.key });
                  renderDialog();
                }
              }}
            />
            <DialogFooter className="mt-4">
              <DefaultButton
                onClick={() => {
                  showDialog = false;
                  renderDialog();
                  resolve(false);
                }}
                text={i18n.t("app:cancel")}
              />
              <PrimaryButton
                onClick={() => {
                  showDialog = false;
                  renderDialog();
                  resolve(true);
                }}
                text={i18n.t("activity:export")}
              />
            </DialogFooter>
          </Dialog>,
          div,
        );
      };

      renderDialog();
    });
  }

  private async _exportActivity() {
    if (this.state.exporting) return;
    this._isMounted && this.setState({ exporting: true });

    try {
      const requestOptions = this._buildActivityRequestOptions();
      const firstResponse: any = await userService.searchActivity("?page=0", requestOptions);
      const totalPages = firstResponse?.data?.totalPages ?? 1;

      const proceed = await this._confirmLargeExport(totalPages);
      if (!proceed) {
        this._isMounted && this.setState({ exporting: false });
        return;
      }

      let allActivity = firstResponse.data.content || [];
      for (let page = 1; page < totalPages; page++) {
        const response: any = await userService.searchActivity("?page=" + page, requestOptions);
        allActivity = allActivity.concat(response.data.content || []);
      }

      const mappedItems = allActivity.map((data: any) => this._mapActivityItem(data, this.state.repoUsers));
      const itemEntriesByItem = mappedItems.map((item: any) => this._getItemEntries(item));
      const hasZipRows = mappedItems.some((item: any) => item.operationType === "DOWNLOAD_AS_ZIP");
      const folderDetailsMap = new Map<string, any>();

      if (hasZipRows) {
        const folderIds = new Set<string>();
        mappedItems.forEach((item: any, index: number) => {
          if (item.operationType !== "DOWNLOAD_AS_ZIP") return;
          const entries = itemEntriesByItem[index] || [];
          entries.forEach((entry) => {
            if (entry.modelType === "FOLDER" && entry.id) folderIds.add(entry.id);
          });
        });

        await Promise.all(
          Array.from(folderIds).map(async (id) => {
            try {
              const response: any = await userService.getMoreFolderDetails(id);
              folderDetailsMap.set(id, response.data);
            } catch (error) {
              console.log(error);
            }
          }),
        );
      }

      const tzOffsetMinutes = this._getUtcOffsetMinutes(this.state.exportTimeZone);
      const content = mappedItems.reduce((rows: any[], item: any, index: number) => {
        const itemEntries = itemEntriesByItem[index] || [];
        itemEntries.forEach((entry) => {
          let foldersInside = "";
          let filesInside = "";
          let totalSize = "";
          if (item.operationType === "DOWNLOAD_AS_ZIP" && entry.modelType === "FOLDER" && entry.id) {
            const details = folderDetailsMap.get(entry.id);
            if (details) {
              foldersInside = details.numberOfFolders ?? "";
              filesInside = details.numberOfDocuments ?? "";
              totalSize = typeof details.size === "number" ? this._getReadableFileSizeString(details.size) : "";
            }
          }

          const row: any = {
            date: item.date ? Moment(item.date).tz(this.state.exportTimeZone).format("Y-MM-DD HH:mm") : "",
            user: item.user ?? "",
            userId: item.userId ?? "",
            action: item.action ?? "",
            item: entry.text ?? "",
            itemId: entry.id ?? "",
            itemType: entry.modelType ?? "",
            details: this._getDetailsText(item),
          };
          if (hasZipRows) {
            row.foldersInside = foldersInside;
            row.filesInside = filesInside;
            row.totalSize = totalSize;
          }
          rows.push(row);
        });
        return rows;
      }, []);

      const headers = [
        i18n.t("activity:date"),
        i18n.t("activity:user"),
        i18n.t("activity:userId"),
        i18n.t("activity:activity"),
        i18n.t("activity:item"),
        i18n.t("activity:itemId"),
        i18n.t("activity:itemType"),
      ];
      if (hasZipRows) {
        headers.push(i18n.t("activity:foldersInside"));
        headers.push(i18n.t("activity:filesInside"));
        headers.push(i18n.t("activity:totalSize"));
      }
      headers.push(i18n.t("activity:details"));

      let ws_name = "Activity_" + Moment().format("YYYYMMDD_HHmm");
      ws_name = ws_name.substring(0, Math.min(ws_name.length, 20));
      const headerKeys = ["date", "user", "userId", "action", "item", "itemId", "itemType"];
      if (hasZipRows) {
        headerKeys.push("foldersInside");
        headerKeys.push("filesInside");
        headerKeys.push("totalSize");
      }
      headerKeys.push("details");
      const ws = XLSXStyle.utils.json_to_sheet(content, { header: headerKeys, skipHeader: true });
      const wb = XLSXStyle.utils.book_new();

      XLSXStyle.utils.book_append_sheet(wb, ws, ws_name);
      XLSXStyle.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

      const getMaxWidth = (key: string, header: string, min: number) => {
        const maxValue = content.reduce((max, row) => Math.max(max, String(row[key] ?? "").length), header.length);
        return Math.max(min, maxValue);
      };

      const cols = [
        { wch: getMaxWidth("date", headers[0], 18) },
        { wch: getMaxWidth("user", headers[1], 16) },
        { wch: getMaxWidth("userId", headers[2], 18) },
        { wch: getMaxWidth("action", headers[3], 20) },
        { wch: getMaxWidth("item", headers[4], 20) },
        { wch: getMaxWidth("itemId", headers[5], 18) },
        { wch: getMaxWidth("itemType", headers[6], 12) },
      ];
      if (hasZipRows) {
        cols.push({ wch: getMaxWidth("foldersInside", headers[7], 14) });
        cols.push({ wch: getMaxWidth("filesInside", headers[8], 14) });
        cols.push({ wch: getMaxWidth("totalSize", headers[9], 12) });
      }
      cols.push({ wch: getMaxWidth("details", headers[headers.length - 1], 30) });
      ws["!cols"] = cols;

      const headerStyle = {
        font: {
          name: "Arial",
          bold: true,
          color: { rgb: "FFFFFFFF" },
        },
        fill: {
          bgColor: { rgb: "FF0F6CBD" },
          fgColor: { rgb: "FF0F6CBD" },
        },
      };

      for (let i = 0; i < headers.length; i++) {
        const cell = XLSXStyle.utils.encode_cell({ r: 0, c: i });
        if (ws[cell]) ws[cell].s = headerStyle;
      }

      XLSXStyle.writeFile(wb, ws_name + ".xlsx", { compression: true });
    } catch (error) {
      console.log(error);
    } finally {
      this._isMounted && this.setState({ exporting: false });
    }
  }
}

function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
  const key = columnKey as keyof T;
  return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}
